module.exports = __webpack_public_path__ + "img/empty.a81a9585.png";